"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classnames = _interopRequireDefault(require("classnames"));

var _colors = require("HubStyleTokens/colors");

var _sizes = require("HubStyleTokens/sizes");

var _I18n = _interopRequireDefault(require("I18n"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _memoizeOne = _interopRequireDefault(require("react-utils/memoizeOne"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Functions = require("../core/Functions");

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _ShareInput = _interopRequireDefault(require("../decorators/ShareInput"));

var _UIIcon = _interopRequireDefault(require("../icon/UIIcon"));

var _FocusProvider = _interopRequireDefault(require("../providers/FocusProvider"));

var _HoverProvider = _interopRequireDefault(require("../providers/HoverProvider"));

var _Fonts = require("../utils/Fonts");

var _MeasureText = require("../utils/MeasureText");

var _decorators = require("../utils/propTypes/decorators");

var _refObject = _interopRequireDefault(require("../utils/propTypes/refObject"));

var _Styles = require("../utils/Styles");

var INPUT_MAX_LENGTH_WARNING_THRESHOLD = 15;

var getStyle = function getStyle(inputWidth) {
  return {
    width: inputWidth
  };
};

var placeholderStyles = (0, _Styles.getPlaceholderStyles)((0, _styledComponents.css)(["color:", ";"], function (_ref) {
  var use = _ref.use;
  return use === 'on-dark' ? _colors.BATTLESHIP : _colors.EERIE;
}));

var computeBackgroundColor = function computeBackgroundColor(_ref2) {
  var focused = _ref2.focused,
      hovered = _ref2.hovered,
      use = _ref2.use;
  if (!focused && !hovered) return 'transparent';
  return use === 'on-dark' ? _colors.HEFFALUMP : _colors.GYPSUM;
};

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "UIAutosizedTextInput__Wrapper",
  componentId: "sc-11ezkl-0"
})(["display:inline-block;position:relative;max-width:100%;color:", ";"], function (_ref3) {
  var use = _ref3.use;
  return use === 'on-dark' && _colors.OLAF;
});

var Input = _styledComponents.default.input.withConfig({
  displayName: "UIAutosizedTextInput__Input",
  componentId: "sc-11ezkl-1"
})(["background-color:transparent;border:0;box-sizing:content-box;color:inherit;cursor:text;max-width:100%;outline:", ";&:not(:empty){display:inline-block;}", ";"], function (_ref4) {
  var affordance = _ref4.affordance;
  return affordance && 0;
}, placeholderStyles);

var Affordance = _styledComponents.default.div.withConfig({
  displayName: "UIAutosizedTextInput__Affordance",
  componentId: "sc-11ezkl-2"
})(["", ""], function (_ref5) {
  var show = _ref5.show;
  return show && (0, _styledComponents.css)(["display:inline-block;margin:-4px 0 -4px -4px;max-width:calc(100% + 4px);padding:4px 38px 4px 4px;background-color:", ";", ";"], computeBackgroundColor, function (_ref6) {
    var focused = _ref6.focused;
    return focused && _Styles.uiFocus;
  });
});

var Icon = (0, _styledComponents.default)(function (props) {
  var __focused = props.focused,
      rest = (0, _objectWithoutProperties2.default)(props, ["focused"]);
  return _react.default.createElement(_UIIcon.default, Object.assign({
    name: "edit",
    size: "small"
  }, rest));
}).withConfig({
  displayName: "UIAutosizedTextInput__Icon",
  componentId: "sc-11ezkl-3"
})(["position:absolute;top:50%;right:10px;transform:translateY(-50%);font-size:", ";color:", ";pointer-events:none;opacity:", ";", ";"], _sizes.INPUT_FONT_SIZE, function (_ref7) {
  var use = _ref7.use;
  return use === 'on-dark' ? _colors.OLAF : _colors.CALYPSO;
}, function (_ref8) {
  var focused = _ref8.focused;
  return focused ? 0 : 1;
}, (0, _Styles.setUiTransition)());

var getCharacterCounterOpacity = function getCharacterCounterOpacity(_ref9) {
  var focused = _ref9.focused,
      maxLength = _ref9.maxLength,
      _ref9$value = _ref9.value,
      value = _ref9$value === void 0 ? '' : _ref9$value;
  return focused && maxLength - value.length <= INPUT_MAX_LENGTH_WARNING_THRESHOLD ? 1 : 0;
};

var CharacterCounter = (0, _styledComponents.default)(function (props) {
  var ariaLiveRegionId = props.ariaLiveRegionId,
      maxLength = props.maxLength,
      _props$value = props.value,
      value = _props$value === void 0 ? '' : _props$value,
      focused = props.focused,
      rest = (0, _objectWithoutProperties2.default)(props, ["ariaLiveRegionId", "maxLength", "value", "focused"]);
  if (!maxLength) return null;
  var charactersRemaining = maxLength - value.length; // Render hidden text when approaching the threshold

  if (charactersRemaining > INPUT_MAX_LENGTH_WARNING_THRESHOLD + 1) {
    return null;
  }

  var displayedCharactersRemaining = charactersRemaining > INPUT_MAX_LENGTH_WARNING_THRESHOLD ? INPUT_MAX_LENGTH_WARNING_THRESHOLD : charactersRemaining;
  return _react.default.createElement("div", rest, _react.default.createElement("span", {
    "aria-hidden": true
  }, displayedCharactersRemaining), getCharacterCounterOpacity({
    focused: focused,
    maxLength: maxLength,
    value: value
  }) === 1 && _react.default.createElement("span", {
    id: ariaLiveRegionId,
    className: "sr-only",
    "aria-live": "polite",
    "aria-atomic": true
  }, _I18n.default.text('ui.autosizedTextInput.charactersRemaining', {
    value: charactersRemaining
  })));
}).withConfig({
  displayName: "UIAutosizedTextInput__CharacterCounter",
  componentId: "sc-11ezkl-4"
})(["position:absolute;top:50%;right:12px;transform:translateY(-50%);font-size:", ";color:", ";pointer-events:none;opacity:", ";", ";"], _sizes.INPUT_FONT_SIZE, function (_ref10) {
  var use = _ref10.use;
  return use === 'on-dark' ? _colors.BATTLESHIP : _colors.EERIE;
}, getCharacterCounterOpacity, (0, _Styles.setUiTransition)());
var uuid = 0;

var UIAutosizedTextInput = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(UIAutosizedTextInput, _PureComponent);

  function UIAutosizedTextInput(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UIAutosizedTextInput);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UIAutosizedTextInput).call(this, props));

    _this.handleClick = function (evt) {
      var _this$props = _this.props,
          inputRef = _this$props.inputRef,
          onClick = _this$props.onClick;
      (0, _Functions.callIfPossible)(onClick, evt);

      if (!evt.preventPrevented) {
        if (inputRef && inputRef.current) inputRef.current.focus();
      }
    };

    _this.state = {
      inputWidth: props.minWidth
    };
    _this._getStyle = (0, _memoizeOne.default)(getStyle);
    _this._ariaLiveRegionId = "uiautosizedtextinput-maxlength-warning-" + uuid++;
    return _this;
  }

  (0, _createClass2.default)(UIAutosizedTextInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.measureWidth(); // Initial width calculation may break when fonts become ready

      if (!(0, _Fonts.fontsLoaded)()) {
        _Fonts.fontsLoadedPromise.then(function () {
          _this2.measureWidth();
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      // ⚠️ This condition prevents infinite loops! ⚠️
      if (prevState.inputWidth === this.state.inputWidth) {
        this.measureWidth();
      }
    }
  }, {
    key: "measureWidth",
    value: function measureWidth() {
      var _this$props2 = this.props,
          inputRef = _this$props2.inputRef,
          minWidth = _this$props2.minWidth;
      if (!inputRef.current) return;
      var newInputWidth = Math.ceil(Math.max(minWidth || 0, (0, _MeasureText.getTextWidth)(inputRef.current)));

      if (this.state.inputWidth !== newInputWidth) {
        this.setState({
          inputWidth: newInputWidth
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props3 = this.props,
          ariaDescribedBy = _this$props3['aria-describedby'],
          affordance = _this$props3.affordance,
          affordanceClassName = _this$props3.affordanceClassName,
          className = _this$props3.className,
          error = _this$props3.error,
          inputClassName = _this$props3.inputClassName,
          inputRef = _this$props3.inputRef,
          __minWidth = _this$props3.minWidth,
          __onBlur = _this$props3.onBlur,
          __onClick = _this$props3.onClick,
          __onFocus = _this$props3.onFocus,
          __onMouseEnter = _this$props3.onMouseEnter,
          __onMouseLeave = _this$props3.onMouseLeave,
          __onMouseMove = _this$props3.onMouseMove,
          readOnly = _this$props3.readOnly,
          use = _this$props3.use,
          maxLength = _this$props3.maxLength,
          value = _this$props3.value,
          rest = (0, _objectWithoutProperties2.default)(_this$props3, ["aria-describedby", "affordance", "affordanceClassName", "className", "error", "inputClassName", "inputRef", "minWidth", "onBlur", "onClick", "onFocus", "onMouseEnter", "onMouseLeave", "onMouseMove", "readOnly", "use", "maxLength", "value"]);
      return _react.default.createElement(_HoverProvider.default, this.props, function (hoverProviderProps) {
        return _react.default.createElement(_FocusProvider.default, _this3.props, function (focusProviderProps) {
          var hovered = hoverProviderProps.hovered,
              hoverProviderRestProps = (0, _objectWithoutProperties2.default)(hoverProviderProps, ["hovered"]);
          var focused = focusProviderProps.focused,
              focusProviderRestProps = (0, _objectWithoutProperties2.default)(focusProviderProps, ["focused"]);
          var inputWidth = _this3.state.inputWidth;
          var hasIcon = affordance && !readOnly;
          return _react.default.createElement(Wrapper, Object.assign({}, hoverProviderRestProps, focusProviderRestProps, {
            className: (0, _classnames.default)('private-expanding-text-input', className),
            focused: focused,
            hovered: hovered,
            onClick: _this3.handleClick,
            use: use
          }), _react.default.createElement(Affordance, {
            className: affordance ? (0, _classnames.default)(affordanceClassName, {
              'private-form__control--error': error
            }) : '',
            focused: focused,
            hovered: hovered,
            show: affordance,
            use: use
          }, _react.default.createElement(Input, Object.assign({}, rest, {
            "aria-describedby": (0, _classnames.default)(ariaDescribedBy, _this3._ariaLiveRegionId),
            value: value,
            maxLength: maxLength,
            affordance: affordance,
            className: inputClassName,
            focused: focused,
            hovered: hovered,
            readOnly: readOnly,
            ref: function ref(_ref11) {
              (0, _Functions.wrapRefObject)(inputRef)((0, _reactDom.findDOMNode)(_ref11));
            },
            style: _this3._getStyle(inputWidth),
            use: use
          }))), hasIcon && _react.default.createElement(CharacterCounter, {
            value: value,
            maxLength: maxLength,
            use: use,
            focused: focused,
            ariaLiveRegionId: _this3._ariaLiveRegionId
          }), hasIcon && _react.default.createElement(Icon, {
            focused: focused,
            use: use
          }));
        });
      });
    }
  }]);
  return UIAutosizedTextInput;
}(_react.PureComponent);

UIAutosizedTextInput.propTypes = {
  value: _propTypes.default.string,
  maxLength: _propTypes.default.number,
  error: _propTypes.default.bool,
  focused: (0, _decorators.hidden)(_propTypes.default.bool),
  hovered: (0, _decorators.hidden)(_propTypes.default.bool),
  minWidth: _propTypes.default.number,
  affordance: _propTypes.default.bool,
  affordanceClassName: _propTypes.default.string,
  inputClassName: _propTypes.default.string,
  inputRef: _refObject.default,
  readOnly: _propTypes.default.bool,
  use: _propTypes.default.oneOf(['default', 'on-dark']).isRequired,
  'aria-describedby': (0, _decorators.hidden)(_propTypes.default.string)
};
UIAutosizedTextInput.defaultProps = {
  affordance: false,
  inputClassName: '',
  use: 'default'
};
UIAutosizedTextInput.displayName = 'UIAutosizedTextInput';

var _default = (0, _ShareInput.default)((0, _Controllable.default)(UIAutosizedTextInput));

exports.default = _default;
module.exports = exports.default;